import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const exitGroupAction = createAsyncAction(
  '@chat/EXIT_GROUP_REQUEST',
  '@chat/EXIT_GROUP_SUCCESS',
  '@chat/EXIT_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState, action: ActionType<typeof exitGroupAction.request>): ChatState => ({
  ...state,
  isLoadingExitGroup: !action.payload?.deleteToo,
  isLoadingExitAndDeleteGroup: !!action.payload?.deleteToo
})

const success = (state: ChatState, action: ActionType<typeof exitGroupAction.success>): ChatState => {
  const inProgressChats = state.inProgressChats.filter(chat => chat.id !== action?.payload?.chatId)

  return {
    ...state,
    ...(action.payload?.deleteToo && { inProgressChats }),
    isSuccessOnExitGroup: true,
    isLoadingExitGroup: false,
    isLoadingExitAndDeleteGroup: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingExitGroup: false,
  isErrorOnExitGroup: true,
  isLoadingExitAndDeleteGroup: false
})

export const exitGroupHandle = { asyncAction: exitGroupAction, request, success, failure }
